import { useEffect, useState } from 'react';
import { DEFAULT_LOCALE_STATE } from '../../common/constants';
export const useMessages = (locale, loaderFn) => {
  const [localeState, setLocaleState] = useState(DEFAULT_LOCALE_STATE);
  useEffect(() => {
    if (!localeState.messages || locale !== localeState.locale) {
      let current = true;
      loaderFn(locale).then(messages => {
        if (current) {
          setLocaleState({
            locale,
            messages: messages !== null && messages !== void 0 ? messages : {}
          });
        }
      });
      return () => {
        current = false;
      };
    }
  }, [loaderFn, locale, localeState]);
  return localeState.messages;
};